import type { NextApiRequest, NextApiResponse } from 'next'
import type { UpdateOrderPayload, UpdateOrderResponse } from 'ecosystem'
import { sveaApi } from 'api'

export const sveaPaymentProvider = async (
  req: NextApiRequest,
  res: NextApiResponse<UpdateOrderResponse | { error: string }>
) => {
  const { sveaPayload }: UpdateOrderPayload = JSON.parse(req.body)

  if (!sveaPayload) {
    res.status(400).json({ error: 'Wrong payload' })
    return
  }

  const { orderId, ...updatedOrder } = sveaPayload

  const { error, data } = await sveaApi.checkout.updateOrder(orderId, updatedOrder)

  if (error) {
    res.status(400).json({ error: error || 'Unknown error' })
    return
  }

  res.status(200).json({ sveaResponse: data } as UpdateOrderResponse)
}
